import classNames from 'classnames'
import React, { FunctionComponent, useRef } from 'react'
import { Transition } from 'react-transition-group'

const defaultTimeout = 500

type Props = {
  isVisible: boolean
  children: React.ReactNode
  className?: string
  timeout?: number
  testId?: string
}

const FadeInContainer: FunctionComponent<Props> = ({
  isVisible,
  children,
  className,
  testId,
  timeout = defaultTimeout,
}: Props) => {
  const nodeRef = useRef(null)
  return (
    <Transition
      in={isVisible}
      timeout={timeout}
      nodeRef={nodeRef}
    >
      {(state) => (
        <div
          ref={nodeRef}
          data-testid={testId}
          className={classNames(
            'fade-in-container',
            className,
            state,
          )}
        >
          {children}
        </div>
      )}
    </Transition>
  )
}

export default FadeInContainer
